module.exports = __webpack_public_path__ + "static/media/sabari.e6010b00.jpg";